"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EventManager {
    get window() {
        return window;
    }
    get document() {
        return document;
    }
    onBlur(callback) {
        this.window.addEventListener('blur', callback);
    }
    onFocus(callback) {
        this.window.addEventListener('focus', callback);
    }
    onMouseMove(callback) {
        this.window.addEventListener('mousemove', callback);
    }
    onKeyUp(callback) {
        this.document.addEventListener('keyup', callback);
    }
    onTouchStart(callback) {
        this.window.addEventListener('touchstart', callback);
    }
    onScroll(callback) {
        this.window.addEventListener('scroll', callback);
    }
    onVisibilityChange(callback) {
        this.document.addEventListener('visibilitychange', () => {
            if (typeof this.document.hidden !== 'undefined') {
                callback(this.document.hidden);
            }
        });
    }
}
exports.EventManager = EventManager;
